import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  Card,
  Table,
  Select,
  Collapse,
  Form,
  message,
  Spin,
  Radio,
  AutoComplete,
  Input,
  Modal,
  Row,
  Col,
  Button,
  Divider,
  Tabs,
  Skeleton,
} from "antd";
import IntlMessages from "../../util/IntlMessages";
import { useHistory } from "react-router-dom";
import moment from "moment";
import BEHAVIOUR_TYPE from "../../Services/DataServices";
import ds from "../../Services/DataServices";
import {
  formatDigits,
  StringIsNullOrEmpty,
  getDecryptID,
} from "../../appRedux/actions/GlobalMethods";
import { Period } from "../../constants/Period";
const TabPane = Tabs.TabPane;

const PerformanceTabSection = (props) => {
  const history = useHistory();

  const PeriodID =
    props && props.periodID ? parseInt(props.periodID) : Period.Day;
  const OutletID = props && props.outletID ? parseInt(props.outletID) : 0;
  const TopReportTypes =
    props && props.topReportProductTypes ? props.topReportProductTypes : [];
  const MainTitle = props && props.mainTitle ? props.mainTitle : [];

  //#region UseSelector

  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  );
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  );
  const getReduxDashboardSearchData = useSelector(
    ({ Reports }) => Reports.dashboardSearchData
  );

  //#endregion UseSelector

  //#region UseState

  const [getLoader, setLoader] = React.useState(true);
  const [getPeriodName, setPeriodName] = React.useState("");
  const [getCurrData, setCurrData] = React.useState({
    currencyCode: "",
    currencyName: "",
    currencySymbol: "",
  });

  const [getMeasureID, setMeasureID] = React.useState(
    TopReportTypes.length > 0 ? TopReportTypes[0].MeasureID : 16
  ); //Revenue : 16 , ItemSold/Quantiy :  11
  const [getSectionColumns, setSectionColumns] = React.useState([]);
  const [getSectionData, setSectionData] = React.useState([]);
  const [getReportTypeID, setReportTypeID] = React.useState(
    TopReportTypes.length > 0 ? TopReportTypes[0].ReportTypeID : 33
  );

  //#endregion UseState

  //#region UseEffect
  React.useEffect(() => {
    let mounted = true;
    if (mounted) {
      const body = {
        PeriodId: PeriodID,
        OutletId: OutletID,
        ReportTypeID:
          TopReportTypes && TopReportTypes[0]
            ? TopReportTypes[0].TopReportID
            : 0,
      };
      getBIDashboardTopReports(body);
    }

    return () => (mounted = false);
  }, [PeriodID, OutletID]);

  React.useEffect(() => {
    let mounted = true;
    if (mounted) {
      const commonData = getReduxCommonSetting;
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {};
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData;
        setCurrData(currencyData);
      }
    }

    return () => (mounted = false);
  }, [getReduxCommonSetting]);
  //#endregion

  function redirectToSalesReport(measureID, reportTypeID) {
    let fromFormatDate = moment().format("YYYY-MM-DDT00:00:00");
    let toFormatDate = moment().format("YYYY-MM-DDT23:59:00");
    let periodID = getReduxDashboardSearchData.PeriodID;

    if (periodID == Period.Month) {
      toFormatDate = moment(toFormatDate).format("YYYY-MM-DD");
      fromFormatDate = moment(toFormatDate)
        .startOf("month")
        .format("YYYY-MM-DD");
    }
    if (periodID == Period.Week) {
      toFormatDate = moment(toFormatDate).format("YYYY-MM-DD");
      fromFormatDate = moment(toFormatDate)
        .startOf("isoWeek")
        .format("YYYY-MM-DD");
    }
    if (periodID == Period.Day) {
      toFormatDate = moment(toFormatDate)
        .endOf("day")
        .format("YYYY-MM-DDTHH:mm:ss");
      fromFormatDate = moment(toFormatDate).format("YYYY-MM-DD");
    }
    let URL = `/dashboard/reporting/salesreports?definition={"ReportId":1,"ReportTypeId":${reportTypeID},"MeasureId":${measureID},"DateTimeFrom":"${fromFormatDate.toString()}","DateTimeTo":"${toFormatDate.toString()}","PeriodId":${periodID},"IsComparision":0,"ComparisionFrom":"","ComparisionTo":""}`;
    history.push(URL);
  }
  async function getBIDashboardTopReports(body) {
    setLoader(true);

    if (PeriodID == Period.Day) {
      setPeriodName("Day");
    }
    if (PeriodID == Period.Week) {
      setPeriodName("Week");
    }
    if (PeriodID == Period.Month) {
      setPeriodName("Month");
    }
    const getReports = ds.getBIDashboardTopRecordsReportsService(
      body,
      BEHAVIOUR_TYPE.POST
    );
    await getReports
      .then((res) => {
        if (res) {
          //#region Products Sold
          let columnHeaders = [];
          let sectionData = [];
          try {
            columnHeaders = JSON.parse(res.data.topHeader);
            let sectionColumns = columnHeaders.map((x) => {
              let sorterdata = false;
              if (x.Value == "Revenue") {
                sorterdata = (a, b) => a.Revenue - b.Revenue;
              }
              return {
                title: x.Value,
                dataIndex: x.Value,
                key: x.Value,
                sorter: sorterdata,
              };
            });

            setSectionColumns(sectionColumns);
          } catch (e) {
            columnHeaders = [];
            setSectionColumns([]);
          }

          if (columnHeaders.length > 0) {
            try {
              sectionData = JSON.parse(res.data.data);
              let dynamicSectionData = [];
              sectionData.map((x, index) => {
                const obj = Object.keys(sectionData[index]).map(
                  (k) => sectionData[index][k]
                );
                let jsonData = {};
                columnHeaders.forEach(function (column, index1) {
                  var columName = column.Value;
                  if (obj[index1].includes("¬~¬")) {
                    obj[index1] = GetReportDynamicLink("product", obj[index1]);
                  } else {
                    if (
                      !Number.isNaN(parseInt(obj[index1])) &&
                      !obj[index1].includes("¬~¬")
                    ) {
                      obj[index1] = formatDigits(
                        obj[index1],
                        getDefaultDecimalPlaces
                      );
                    }
                    if (obj[index1].includes("¬~¬")) {
                      obj[index1] =
                        obj[index1] != null
                          ? obj[index1].includes("¬~¬")
                            ? obj[index1].split("¬~¬")[1]
                            : obj[index1]
                          : obj[index1];
                    }
                  }

                  jsonData[columName] = obj[index1];
                });
                dynamicSectionData.push(jsonData);
              });
              setSectionData(dynamicSectionData);
            } catch (e) {
              sectionData = [];
              setSectionData([]);
            }
          } else {
            setSectionData([]);
          }
          //#endregion Products Sold

          setLoader(false);
        }
      })
      .catch((e) => {
        // message.error("Something Went Wrong...");
      });
  }
  const onChange = (key) => {
    if (TopReportTypes.length > 1) {
      const reportTypes =
        TopReportTypes &&
        TopReportTypes.filter((x) => x.TopReportID == key) &&
        TopReportTypes.filter((x) => x.TopReportID == key)[0]
          ? TopReportTypes.filter((x) => x.TopReportID == key)[0]
          : [];

      if (
        reportTypes.MeasureID != undefined &&
        reportTypes.ReportTypeID != undefined
      ) {
        setMeasureID(reportTypes.MeasureID);
        setReportTypeID(reportTypes.ReportTypeID);
      }

      const body = {
        PeriodId: PeriodID,
        OutletId: OutletID,
        ReportTypeID: parseInt(reportTypes.TopReportID),
      };
      getBIDashboardTopReports(body);
    } else {
      // message.success("Hi");
    }
  };
  const GetReportDynamicLink = (key, value) => {
    let reportType =
      key && key != undefined ? key.trim().replace(" ", "").toLowerCase() : "";
    let id =
      value.split("¬~¬")[0] != undefined &&
      !StringIsNullOrEmpty(value.split("¬~¬")[0])
        ? value.split("¬~¬")[0].trim() != "0&"
          ? value
              .split("¬~¬")[0]
              .trim()
              .concat("&_c1c3-444d-4ca7-8c52-9ac1853c44a6")
          : ""
        : "";

    let displayValue =
      value.split("¬~¬")[1] != undefined
        ? value.split("¬~¬")[1].trim().split("<")[0]
        : value.split("¬~¬")[0];
    let redirectURL = "";

    if (displayValue.includes("N/A")) {
      displayValue = `No ${key.Value}`;
    }

    if (!StringIsNullOrEmpty(id)) {
      switch (reportType) {
        case "summary":
          redirectURL = "";
          break;
        case "user":
          redirectURL = `/dashboard/setup/users/edit/${id}/1`;
          break;
        case "outlet":
          redirectURL = `/Dashboard/setup/outletsandregisters/editoutlet/${id}/1`;
          break;
        case "register":
          redirectURL = `/Dashboard/setup/outletsandregisters/editregister/${id}/1`;
          break;
        case "customer":
          redirectURL = `/dashboard/customers/addcustomer/${id}`;
          break;
        case "customergroup":
          redirectURL = `/dashboard/Customers/customergroup/${id}`;
          break;
        case "promotion":
          redirectURL = `/Dashboard/products/promotions/edit/${id}`;
          break;
        case "saleschannel":
          redirectURL = ``;
          break;
        case "product":
          redirectURL = `/Dashboard/products/main/edit/${id}`;

          break;
        case "sku":
          redirectURL = `/Dashboard/products/main/edit/${id}`;
          break;
        case "brand":
          // redirectURL = `/dashboard/products/Brands/${id}`;
          redirectURL = `/dashboard/products/main/listing/brandid/${id}`;
          break;
        case "supplier":
          redirectURL = `/Dashboard/products/supplier/edit/${getDecryptID(id)}`;
          break;
        case "producttype":
          // redirectURL = `/dashboard/products/producttypes/${id}`;
          redirectURL = `/dashboard/products/main/listing/typeid/${id}`;
          break;
        case "tag":
          // redirectURL = `/dashboard/products/producttags/${id}`;
          redirectURL = `/dashboard/products/main/listing/tagid/${id}`;
          break;
        case "productvariant":
          redirectURL = `/Dashboard/products/main/edit/${id}`;
          break;
        default:
          redirectURL = "";
          break;
      }
    }

    return !StringIsNullOrEmpty(redirectURL) ? (
      <span
        className="dk-text-reporting "
        onClick={() => {
          history.push(redirectURL);
        }}
        style={{ fontWeight: "400" }}
      >
        <div dangerouslySetInnerHTML={{ __html: displayValue }}></div>
      </span>
    ) : (
      <span style={{ fontWeight: "400" }}>{displayValue}</span>
    );
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const obj = sorter;
  };

  return (
    <Card className='gx-card pd-card'
      title={
        <h3 className="">
          {" "}
          <IntlMessages id={MainTitle} />
        </h3>
      }
      extra={
        <div
          className="gx-link gx-btn-link"
          onClick={() => redirectToSalesReport(getMeasureID, getReportTypeID)}
        >
          <IntlMessages id="dashboard.dashboardreporting.viewreport" />
        </div>
      }
    >
      <Tabs
        defaultActiveKey={
          TopReportTypes && TopReportTypes[0] ? TopReportTypes[0].ID : 0
        }
        onChange={(e) => onChange(e)}
      >
        {TopReportTypes &&
          TopReportTypes.map((x) => {
            return (
              <>
                <TabPane tab={<IntlMessages id={x.DisplayName} />} key={x.TopReportID}>
                  {getLoader ? (
                    <Skeleton count={5} height={5} />
                  ) : (
                    <Table
                      className="gx-table-responsive"
                      columns={getSectionColumns}
                      dataSource={getSectionData}
                      pagination={false}
                      sortDirections={["ascend", "descend"]}
                      onChange={handleTableChange}
                      // footer={() => (props.isFooter ? <FooterSeeMore /> : "")}
                    />
                  )}
                </TabPane>
              </>
            );
          })}
      </Tabs>
    </Card>
  );
};

export default PerformanceTabSection;
